var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.open)?_c('div',{staticClass:"context-menu",style:(_vm.style),on:{"click":_vm.onClick,"!contextmenu":function($event){$event.preventDefault();}}},[_vm._t("default")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }